export default __webpack_public_path__ + "static/microphone_w.f803441a531feff8b54ffe4f719141b1.svg";